{
  "familyId": "TAA-WOORD-IDIOOM",
  "questions": [
    {
      "id": "TAA-WOORD-IDIOOM-001",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Wat betekent 'iemand een hart onder de riem steken'?",
      "options": ["Iemand moed inspreken", "Iemand een cadeau geven", "Iemand een riem lenen", "Iemand pijn doen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Uitdrukkingen", "content": "Een uitdrukking (idioom) betekent iets anders dan de losse woorden. 'Een hart onder de riem steken' heeft niets te maken met een echt hart of een echte riem — het betekent: iemand moed geven.", "icon": "lightbulb" } }],
      "conceptId": "idioom_hart_riem",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Iemand een hart onder de riem steken' is een uitdrukking die betekent: iemand moed inspreken of bemoedigen. Het heeft niets te maken met een echt hart of een echte riem.",
        "solutionSteps": ["Dit is een uitdrukking (idioom)", "Niet letterlijk nemen!", "'Hart' staat hier voor moed/kracht", "Betekenis: iemand moed inspreken"],
        "distractorExplanations": {
          "0": "Goed! 'Een hart onder de riem steken' = iemand moed inspreken.",
          "1": "Je dacht waarschijnlijk dat het iets met geven te maken heeft. Maar het gaat niet om een echt cadeau — het gaat om moed geven. Onthoud: uitdrukkingen zijn niet letterlijk.",
          "2": "Je dacht waarschijnlijk dat het letterlijk over een riem gaat. Maar uitdrukkingen betekenen iets anders dan de losse woorden. Onthoud: zoek de figuurlijke betekenis.",
          "3": "Je dacht waarschijnlijk dat 'steken' hier pijn doen betekent. Maar in deze uitdrukking betekent het juist het tegenovergestelde: iemand helpen. Onthoud: kijk naar de hele uitdrukking, niet naar één woord."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-cadeau", "label": "Neemt uitdrukking letterlijk (cadeau)", "optionIndex": 1 },
          { "id": "taa.idioom-letterlijk-riem", "label": "Neemt uitdrukking letterlijk (riem)", "optionIndex": 2 },
          { "id": "taa.idioom-letterlijk-steken", "label": "Neemt 'steken' letterlijk (pijn)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-002",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Lisa heeft vlinders in haar buik. Wat betekent dat?",
      "options": ["Ze is zenuwachtig of opgewonden.", "Ze heeft buikpijn.", "Ze heeft vlinders gezien.", "Ze heeft honger."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Figuurlijk taalgebruik", "content": "Bij figuurlijk taalgebruik bedoel je iets anders dan wat de woorden letterlijk zeggen. 'Vlinders in je buik' = een kriebelig, zenuwachtig gevoel.", "icon": "lightbulb" } }],
      "conceptId": "idioom_vlinders_buik",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Vlinders in je buik' is figuurlijk taalgebruik. Het betekent dat je zenuwachtig of opgewonden bent — bijvoorbeeld voor een optreden of een eerste afspraakje. Er zitten geen echte vlinders in je buik!",
        "solutionSteps": ["Dit is figuurlijk taalgebruik", "'Vlinders' = kriebelig gevoel", "Betekenis: zenuwachtig of opgewonden zijn"],
        "distractorExplanations": {
          "0": "Goed! 'Vlinders in je buik' = zenuwachtig of opgewonden zijn.",
          "1": "Je dacht waarschijnlijk dat het letterlijk over buikpijn gaat. Maar het is figuurlijk — het kriebelige gevoel lijkt op vlinders. Onthoud: uitdrukkingen zijn niet letterlijk.",
          "2": "Je dacht waarschijnlijk dat Lisa echte vlinders heeft gezien. Maar 'vlinders in je buik' is een uitdrukking. Onthoud: als iets vreemd klinkt, is het waarschijnlijk figuurlijk.",
          "3": "Je dacht waarschijnlijk dat het buikgevoel honger is. Maar 'vlinders' beschrijft een zenuwachtig gevoel, niet honger. Onthoud: kijk naar de context van de zin."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-buikpijn", "label": "Neemt uitdrukking letterlijk (buikpijn)", "optionIndex": 1 },
          { "id": "taa.idioom-letterlijk-vlinders", "label": "Neemt uitdrukking letterlijk (echte vlinders)", "optionIndex": 2 },
          { "id": "taa.idioom-letterlijk-honger", "label": "Verwart buikgevoel met honger", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-003",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Welke uitdrukking betekent 'heel hard werken'?",
      "options": ["Je uit de naad werken", "Met je neus in de boter vallen", "De spijker op de kop slaan", "Door de mand vallen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Uitdrukkingen over werken", "content": "'Je uit de naad werken' = heel hard werken. 'Met je neus in de boter vallen' = geluk hebben. 'De spijker op de kop slaan' = precies goed raden. 'Door de mand vallen' = betrapt worden.", "icon": "lightbulb" } }],
      "conceptId": "idioom_hard_werken",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Je uit de naad werken' betekent heel hard werken — zo hard dat je kleren er bijna van scheuren. De andere uitdrukkingen betekenen iets heel anders.",
        "solutionSteps": ["'Je uit de naad werken' = heel hard werken ✓", "'Met je neus in de boter vallen' = geluk hebben", "'De spijker op de kop slaan' = precies goed raden", "'Door de mand vallen' = betrapt worden"],
        "distractorExplanations": {
          "0": "Goed! 'Je uit de naad werken' = heel hard werken.",
          "1": "Je dacht waarschijnlijk dat 'met je neus in de boter vallen' hard werken is. Maar het betekent geluk hebben — je komt precies op het goede moment. Onthoud: boter = iets lekkers = geluk.",
          "2": "Je dacht waarschijnlijk dat 'de spijker op de kop slaan' hard werken is. Maar het betekent precies goed raden of zeggen. Onthoud: de spijker raakt precies de goede plek.",
          "3": "Je dacht waarschijnlijk dat 'door de mand vallen' hard werken is. Maar het betekent betrapt worden op een leugen. Onthoud: je valt door de mand = je bedrog wordt ontdekt."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.idioom-verwisseld-boter", "label": "Verwart 'neus in boter' met hard werken", "optionIndex": 1 },
          { "id": "taa.idioom-verwisseld-spijker", "label": "Verwart 'spijker op kop' met hard werken", "optionIndex": 2 },
          { "id": "taa.idioom-verwisseld-mand", "label": "Verwart 'door de mand' met hard werken", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-004",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "De docent zei: 'Jullie maken van een mug een olifant.' Wat bedoelt ze?",
      "options": ["Jullie overdrijven.", "Jullie zijn sterk.", "Jullie zijn slim.", "Jullie zijn luidruchtig."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Van een mug een olifant maken", "content": "Een mug is heel klein, een olifant heel groot. Als je van een mug een olifant maakt, maak je iets kleins veel groter dan het is. Dat heet overdrijven.", "icon": "lightbulb" } }],
      "conceptId": "idioom_mug_olifant",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Van een mug een olifant maken' betekent overdrijven — je maakt iets kleins (een mug) veel groter dan het is (een olifant). De docent vindt dat de leerlingen overdrijven.",
        "solutionSteps": ["Mug = iets kleins", "Olifant = iets groots", "Van klein iets groots maken = overdrijven", "Antwoord: jullie overdrijven"],
        "distractorExplanations": {
          "0": "Goed! 'Van een mug een olifant maken' = overdrijven.",
          "1": "Je dacht waarschijnlijk dat het over kracht gaat (een olifant is sterk). Maar het gaat over grootte: iets kleins groter maken dan het is. Onthoud: mug → olifant = klein → groot = overdrijven.",
          "2": "Je dacht waarschijnlijk dat het over slimheid gaat. Maar de uitdrukking gaat over overdrijven, niet over slim zijn. Onthoud: kijk naar het contrast (mug vs olifant = klein vs groot).",
          "3": "Je dacht waarschijnlijk dat het over geluid gaat. Maar 'van een mug een olifant maken' gaat over het groter maken van een probleem, niet over geluid. Onthoud: het gaat om de grootte, niet het geluid."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-olifant-sterk", "label": "Neemt 'olifant' letterlijk (sterk)", "optionIndex": 1 },
          { "id": "taa.idioom-letterlijk-olifant-slim", "label": "Interpreteert uitdrukking als slim", "optionIndex": 2 },
          { "id": "taa.idioom-letterlijk-olifant-luid", "label": "Interpreteert uitdrukking als luidruchtig", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-005",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "matching",
      "question": "Koppel elke uitdrukking aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Met de deur in huis vallen", "Iets door de vingers zien", "Op je tellen passen", "De knoop doorhakken"],
        "rightItems": ["Meteen ter zake komen", "Iets laten gaan / niet bestraffen", "Voorzichtig zijn", "Een beslissing nemen"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Uitdrukkingen onthouden", "content": "Probeer een beeld te maken bij elke uitdrukking. 'Met de deur in huis vallen' = je valt meteen naar binnen = je komt meteen ter zake. 'De knoop doorhakken' = je hakt de knoop door = je neemt een beslissing.", "icon": "lightbulb" } }],
      "conceptId": "idioom_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "'Met de deur in huis vallen' = meteen ter zake komen. 'Iets door de vingers zien' = iets laten gaan. 'Op je tellen passen' = voorzichtig zijn. 'De knoop doorhakken' = een beslissing nemen.",
        "solutionSteps": ["Met de deur in huis vallen → meteen ter zake komen", "Iets door de vingers zien → iets laten gaan", "Op je tellen passen → voorzichtig zijn", "De knoop doorhakken → een beslissing nemen"]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-WOORD-IDIOOM-006",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "categorize",
      "question": "Sorteer de uitdrukkingen: gaan ze over GELUK of over MOED?",
      "data": {
        "categories": ["Geluk", "Moed"],
        "items": [
          { "text": "Met je neus in de boter vallen", "correctCategory": 0 },
          { "text": "Iemand een hart onder de riem steken", "correctCategory": 1 },
          { "text": "Mazzel hebben", "correctCategory": 0 },
          { "text": "De stoute schoenen aantrekken", "correctCategory": 1 },
          { "text": "Boffen", "correctCategory": 0 },
          { "text": "Door de zure appel bijten", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Geluk of moed?", "content": "Geluk: 'met je neus in de boter vallen' (geluk hebben), 'mazzel hebben', 'boffen'. Moed: 'hart onder de riem steken' (aanmoedigen), 'stoute schoenen aantrekken' (durven), 'door de zure appel bijten' (doorzetten).", "icon": "lightbulb" } }
      ],
      "conceptId": "idioom_categoriseer_geluk_moed",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Geluk-uitdrukkingen: 'met je neus in de boter vallen', 'mazzel hebben', 'boffen'. Moed-uitdrukkingen: 'hart onder de riem steken' (aanmoedigen), 'de stoute schoenen aantrekken' (durven), 'door de zure appel bijten' (doorzetten).",
        "solutionSteps": [
          "Met je neus in de boter vallen → geluk hebben",
          "Hart onder de riem steken → aanmoedigen (moed)",
          "Mazzel hebben → geluk",
          "De stoute schoenen aantrekken → durven (moed)",
          "Boffen → geluk",
          "Door de zure appel bijten → doorzetten (moed)"
        ]
      }
    }
  ]
}